export const LEFT_SIDEBAR = {
  WIDTH: 272,
};
